module.exports = __webpack_public_path__ + "static/img/PL.eade648.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/PL.png
// module id = UAHk
// module chunks = 1